import React, { Component } from 'react'
import styled from 'styled-components'

const CodeTabsHeaderWrapper = ({ attributes, children, element }) => {
  const { noTabs } = element

  return (
    <CodeTabsHeader {...attributes} noTabs={noTabs || false}>
      {children}
    </CodeTabsHeader>
  )
}

export default CodeTabsHeaderWrapper

const CodeTabsHeader = styled.ul`
  list-style-type: none;
  display: ${props => (props.noTabs === false ? 'flex' : 'none')};
  max-width: 100%;
  margin: 0px;
  padding: 0px;
`
